export const SET_TOAST_MESSAGE = "SET_TOAST_MESSAGE";
export const DISMISS_TOAST_MESSAGE = "DISMISS_TOAST_MESSAGE";

export const TOAST_SUCCESS = "success";
export const TOAST_FAIL = "fail";
export const TOAST_ALERT = "alert";

